// src/com/auto_plan_upload/AutoPlanUploadGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * AUTO_PLAN_UPLOAD Apollo Graphql
 * 자동배차 준비 정보
 * Project: NewTOP for cloud
 * 2025-03-13 09:51:11 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const AUTO_PLAN_UPLOAD_LIST_PART = gql`
fragment AutoPlanUploadListPart on AutoPlanUpload {
    arriveId
    dcCd
    planDate
    storeId
    leftOver
    totVol
    nBulkPt
    yBulkPt
    oBulkPt
    pbsPt15
    storeCpp
    prePt17
    dayPt04
    dayPt11
    dayPt15
    dayPt18
    totalPt
    restOverPt
    nextday04Pt
    updateDate
    endBool
    regDate
    regUser
    basicDockno
    distanceOne
    basicExpectRunTime
    startReqTimeToday
    arriveReqTimeNext
    firstShipTime
    lastShipTime
    storeApplyCom
    loadMaxCnt
    storeName
    comName
	mainVehTypeName
    maxVehTypeName
    didaNote
    regUserName
}
`;


export const LIST_AUTO_PLAN_UPLOAD = gql`
${AUTO_PLAN_UPLOAD_LIST_PART}
query ListAutoPlanUpload($planDate:String!) {
    autoPlanUploadList(planDate:$planDate) {
        ...AutoPlanUploadListPart
    }
}
`;

export const GET_AUTO_PLAN_UPLOAD = gql`
${AUTO_PLAN_UPLOAD_LIST_PART}
query GetAutoPlanUpload($storeId:String!, $planDate:String!) {
    autoPlanUploadItem(storeId:$storeId, planDate:$planDate) {
        ...AutoPlanUploadListPart
    }
}
`;

export const ADD_AUTO_PLAN_UPLOAD = gql`
mutation AddAutoPlanUpload($autoPlanUpload:InputAutoPlanUploadAdd!) {
	autoPlanUploadAdd(autoPlanUpload: $autoPlanUpload) {
		ok
		message
	}
}
`;

export const EDIT_AUTO_PLAN_UPLOAD = gql`
mutation EditAutoPlanUpload($autoPlanUpload:InputAutoPlanUploadEdit!) {
	autoPlanUploadEdit(autoPlanUpload: $autoPlanUpload) {
		ok
		message
	}
}
`;

export const REMOVE_AUTO_PLAN_UPLOAD = gql`
mutation RemoveAutoPlanUpload($autoPlanUpload:InputAutoPlanUploadRemove!) {
	autoPlanUploadRemove(autoPlanUpload: $autoPlanUpload) {
		ok
		message
	}
}
`;

/*
input InputAutoPlanUploadUpload {
	dcCd: String
	planDate: String!
    list: [InputAutoPlanUploadItem!]!
}
*/
export const UPLOAD_AUTO_PLAN_UPLOAD = gql`
mutation UploadAutoPlanUpload($autoPlanUpload:InputAutoPlanUploadUpload!) {
    autoPlanUploadUpload(autoPlanUpload: $autoPlanUpload) {
        ok
        message
        list {
            planDate
            storeId
            ok
            message
        }
    }
}
`;

/*
 * 상온 자동배차 화면을 위한 GQL
 * autoPlanUploadList + autoPlanBindList + autoPlanList + autoCppInfoStateHeaderItem
 * 데이터 가져온 후 autoPlanUploadList 각 row에 autoPlanBindList, autoPlanList 아이템을 선별 추가.
 * autoPlanBindList(planDate:String!): [AutoPlanBind]!
 * autoPlanList(planDate:String!): [AutoPlan]!
 * autoCppInfoStateHeaderItem 데이터는 별도로 헤더에 사용.
 * autoCppInfoStateHeaderItem(planDate:String!): AutoCppInfo
 */

/*

gql test.

  autoCppInfoStateHeaderItem(planDate: "2025-03-13") {
    dcName
    dcCd
    dayTotVol
    cppTot
    tpc
    fillRate
    leftOver
    processStep
    vehTotCnt
    updateDate
    regDate
    tpcTarget
  }


  autoPlanBindList(planDate:"2025-03-15") {
    dcCd
    planDate
    bindIndex
    targetStoreId
    targetHocha
    bindStoreId
    regDate
  }


  autoPlanList(planDate:"2025-03-13") {
    arriveId
    dcCd
    planDate
    hocha
    storeId
    storeApplyCom
    vehTypeId
    vehTypeName
    vehPtCapa
    nextDay
    shprTime
    startTime
    arriveTime
    returnTime
    bindBool
    chargeGood
    tsrPrinted
    note
    regTypeCd
    regDate
    regUser
    storeName
    basicExpectRunTime
    vehTypeAlias
    planId
    comId
    vehPlates
  }

*/

// 상온 자동배차 화면을 위한 모든 정보를 한번에 가져오는 GQL
export const AUTO_PLAN_ALL_STATE = gql`
${AUTO_PLAN_UPLOAD_LIST_PART}
query AutoPlanAllState($planDate:String!) {
    autoPlanUploadList(planDate:$planDate) {
        ...AutoPlanUploadListPart
    }
    autoPlanBindList(planDate:$planDate) {
        dcCd
        planDate
        bindIndex
        targetStoreId
        targetHocha
        bindStoreId
        bindHocha
        regDate
    }
    autoPlanList(planDate:$planDate) {
        arriveId
        dcCd
        planDate
        hocha
        storeId
        storeApplyCom
        vehTypeId
        vehTypeName
        vehPtCapa
        nextDay
        shprTime
        startTime
        arriveTime
        returnTime
        bindBool
        chargeGood
        tsrPrinted
        note
        regTypeCd
        storeName
        basicExpectRunTime
        vehTypeAlias
        planId
        comId
        vehPlates
    }
    autoCppInfoStateHeaderItem(planDate:$planDate) {
        dcName
        dcCd
        dayTotVol
        cppTot
        tpc
        fillRate
        leftOver
        processStep
        vehTotCnt
        updateDate
        regDate
        tpcTarget
    }
}
`;
